import * as React from 'react'
import styled from 'styled-components'
import { BodyText } from '../../../../common/src/components/core'
import { dateFmt, timeFmt } from '../../../../common/src/date'
import { nPlural } from '../../../../common/src/format'
import { FetchThreadQuery, ActionName } from '../../../../common/src/types.gen'

interface ThreadActionSummary {
  // If the action was a SNOOZE_THREAD action, the summary will have the field `ArchiveDays` that represents how long the thread will snooze. We want to display this number in the thread history.
  archiveDays?: number
}

/**
 * this component displays a single action item's display name, the time it happened, and the user who did the action or "bot" if the action was executed by the bot.
 */
export const ThreadActionItem = ({
  recentAction,
}: {
  recentAction: FetchThreadQuery['thread']['recentActions'][0]
}) => (
  <ActionItemContainer>
    {`${actionDisplayVerb(recentAction)} on ${dateFmt(recentAction.timeCreated)} at ${timeFmt(
      recentAction.timeCreated
    )} by ${recentAction.user == null ? 'bot' : recentAction.user.name}`}
  </ActionItemContainer>
)

function actionDisplayVerb(recentAction: FetchThreadQuery['thread']['recentActions'][0]) {
  switch (recentAction.actionName) {
    case ActionName.ARCHIVE:
      return 'Archived'
    case ActionName.UNARCHIVE:
      return 'Unarchived'
    case ActionName.SNOOZE_THREAD:
      // If the recentAction's summary has `archiveDays` display it, otherwise just say we snoozed the thread.
      const summary = JSON.parse(recentAction.summary) as ThreadActionSummary
      const archiveDays = summary.archiveDays
      if (archiveDays && typeof archiveDays === 'number') {
        return `Snoozed for ${nPlural(archiveDays as number, 'day')}`
      }
      return 'Snoozed thread'
    case ActionName.START_BOT:
      return 'Started bot'
    case ActionName.STOP_BOT:
      return 'Stopped bot'

    default:
      return recentAction.actionDisplayName
  }
}

const ActionItemContainer = styled(BodyText)`
  width: 100%;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 32px;
`
